module.exports = __webpack_public_path__ + "static/img/c1.7eb73ec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/success/c1.png
// module id = OzUG
// module chunks = 0